<template>
    <div class="video-editor">
        <div class="article-title">
            <div class="name-wrapper">
                <h3>동영상 게시판</h3>
            </div>
        </div>
        <div class="article-demonstrate">
            <li class="demonstration">동영상 게시판입니다. 비메오 번호 입력 또는 직접 업로드를 해주세요</li>
        </div>
        <div class="video-container">
            <div class="video-title-wrapper">
                <el-input placeholder="제목을 입력해주세요." v-model="title"></el-input>
            </div>
            <div class="video-title-wrapper">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="학년">
                        <el-select v-model="cat" @change="gradeChanged" placeholder="학년" style="width: 150px;">
                            <el-option
                                    v-for="item in grades"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>&nbsp;
                    </el-form-item>
                    <el-form-item label="단원">
                        <el-select v-model="cat2" placeholder="단원" style="width: 150px;">
                            <el-option
                                    v-for="item in subjects"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="비메오 번호">
                        <el-input placeholder="비메오 URL 번호 (예시: 67741947)" style="width: 150px;" v-model="vimeo_num"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="video-upload-wrapper">
                <el-upload
                        class="upload-demo"
                        drag
                        action=""
                        ref="upload"
                        :show-file-list="false"
                        :http-request="upload"
                        v-loading="loading">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text"><em>{{ desc }}</em></div>
                </el-upload>
            </div>
            <div class="video-buttons-wrapper">
                <el-button type="primary" @click="saveContent">등록</el-button>
                <el-button @click="writeCancel">취소</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import datas from '../../assets/data.json'

    export default {
        name: "VideoEditor",
        components: {
        },
        data() {
            return {
                title: '',
                content: '',
                vimeo_num: '',
                type: '',
                cat: '',
                cat2: '',
                loading: false,
                desc: "눌러서 영상을 업로드하세요.",
                id: undefined,
                grades: [],
                subjects: []
            }
        },
        created() {
            this.grades = datas.grades
            this.subjects = datas.subjects
            this.id = this.$route.params.id;
            if (this.id !== undefined) {
                this.$http.get(`/api/article/${this.id}`)
                    .then((result) => {
                        this.title = result.data.title;
                        this.cat = result.data.cat;
                        this.cat2 = result.data.cat2;
                        this.gradeChanged()
                        this.vimeo_num = result.data.content.split('/')[2];
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
            this.type = window.location.href.split('/')[3];
        },
        methods: {
          async gradeChanged() {
            this.$http.get(`/api/chapter/${this.cat[2]}`)
              .then((result) => {
                this.subjects = []
                for (const data of result.data) {
                  const temp = {
                    value: `${data.id}`,
                    label: `${data.name}`
                  };
                  this.subjects.push(temp);
                }
                this.query.cat2 = null;
              })
          },
            writeCancel() {
                this.$router.go(-1);
            },
            saveContent() {
                this.$http.defaults.headers['x-access-token'] = this.token;
                if (this.token === null) {
                    alert("로그인 되어있지 않습니다.");
                } else if (this.loading === true) {
                    alert("동영상을 업로드 중입니다.");
                } else if (this.title === '' || (this.content === '' && this.vimeo_num === '')) {
                    alert("글과 내용은 필수항목입니다.");
                } else {
                    if (this.content === '') this.content = '/video/' + this.vimeo_num
                    this.$http.post(`/api/article/${this.type}/write`, {
                        title: this.title,
                        content: this.content,
                        cat: this.cat,
                        cat2: this.cat2,
                        id: this.id
                    }).then(() => {
                        this.$router.push(`/${this.type}`)
                    }).catch((err) => {
                        console.log(err);
                        alert("글 등록에 실패했습니다.");
                    })
                }
            },
            upload() {
                const file = this.$refs.upload.uploadFiles[0];
                if (!file.name.match(/.(mp4|flv|mkv|mov|wmv|avi)$/i)) {
                    alert("유효한 영상 형식이 아닙니다.")
                } else {
                    const formData = new FormData();
                    formData.append('file', file.raw);
                    this.loading = true;
                    this.$http.post('/api/upload', formData).then(res => {
                        this.content = res.data.uri;
                        this.$refs.upload.clearFiles();
                        this.loading = false;
                        this.desc = "영상 업로드가 완료되었습니다.";
                    })
                }
            }
        },
        computed: mapGetters({
            token: "getToken",
            username: "getUsername"
        })
    }
</script>

<style>
    .video-editor {
        max-width: 874px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 15px;
    }
    .article-title {
        width: 100%;
        border-bottom: 2px solid #bcbcbc;
        margin: 0 auto;
        display: flex;
        text-align: left;
    }
    .name-wrapper {
        float: left;
        line-height: 22px;
        letter-spacing: -1px;
        display: inline-block;
    }
    .name-wrapper > h3 {
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .article-demonstrate {
        width: 100%;
        margin: 0 auto;
        display: inline-block;
    }
    .demonstration {
        display: list-item;
        text-align: -webkit-match-parent;
        margin-top: 10px;
        margin-bottom: 4px;
        color: #888;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: -.3px;
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        list-style: none;
        float: left;
    }
    .video-container {
        width: 100%;
        height: auto;
        padding: 20px 20px;
        margin: 0 auto;
        border: 2px solid #d5d5d5;
        display: flow-root;
        box-sizing: border-box;
    }
    .video-title-wrapper {
        text-align: left;
        margin-bottom: 10px;
    }
    .upload-demo {
    }
    .el-upload {
        width: 100%;
    }
    .el-upload-dragger{
        width: 100%;
        height: 440px;
    }
    .el-icon-upload {
        position: absolute;
        top: 33%;
        left: 46%
    }
    .el-upload__text {
        position: relative;
        margin: 0 auto;
        top: 55%;
    }
    .video-upload-wrapper {
        display: inline-block;
        width: 100%;
    }
    .video-buttons-wrapper > button {
        float: right;
        margin-left: 10px;
    }
</style>